<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7501_5321)">
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint0_linear_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint1_linear_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint2_linear_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint3_linear_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint4_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint5_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint6_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint7_linear_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint8_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint9_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint10_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint11_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint12_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint13_radial_7501_5321)"
      />
      <rect x="7.2251"
            y="4.10938"
            width="20.3047"
            height="25.7891"
            rx="1.4"
            fill="url(#paint14_radial_7501_5321)"
            fill-opacity="0.49"
      />
      <path d="M18.9932 4.10938H8.88921C8.17496 4.10938 7.29403 4.73618 7.29403 5.50937L7.24219 28.4646C7.24219 28.9978 8.01625 29.3277 8.54929 29.3134L22.8652 28.931C23.5259 28.931 24.0614 27.661 24.0614 26.9458L23.6537 9.53761C23.6537 9.29229 23.5637 9.05702 23.4034 8.88355L18.9932 4.10938Z"
            fill="url(#paint15_linear_7501_5321)"
      />
      <path d="M18.9932 4.10938H8.88921C8.17496 4.10938 7.29403 4.73618 7.29403 5.50937L7.24219 28.4646C7.24219 28.9978 8.01625 29.3277 8.54929 29.3134L22.8652 28.931C23.5259 28.931 24.0614 27.661 24.0614 26.9458L23.6537 9.53761C23.6537 9.29229 23.5637 9.05702 23.4034 8.88355L18.9932 4.10938Z"
            fill="url(#paint16_radial_7501_5321)"
      />
      <path d="M19.8255 4.35397H8.83772C8.061 4.35397 7.10301 4.98074 7.10301 5.75397L7.04663 28.7092C7.04663 29.251 7.85626 29.573 8.39796 29.5597L24.0361 29.1756C24.7546 29.1756 25.337 27.9056 25.337 27.1904L24.8937 9.7822C24.8937 9.53688 24.7958 7.63746 24.6215 7.46398C24.9193 5.08896 23.605 4.54902 19.8255 4.35397Z"
            fill="url(#paint17_linear_7501_5321)"
      />
      <path d="M19.8255 4.35397H8.83772C8.061 4.35397 7.10301 4.98074 7.10301 5.75397L7.04663 28.7092C7.04663 29.251 7.85626 29.573 8.39796 29.5597L24.0361 29.1756C24.7546 29.1756 25.337 27.9056 25.337 27.1904L24.8937 9.7822C24.8937 9.53688 24.7958 7.63746 24.6215 7.46398C24.9193 5.08896 23.605 4.54902 19.8255 4.35397Z"
            fill="url(#paint18_linear_7501_5321)"
      />
      <path d="M19.8255 4.35397H8.83772C8.061 4.35397 7.10301 4.98074 7.10301 5.75397L7.04663 28.7092C7.04663 29.251 7.85626 29.573 8.39796 29.5597L24.0361 29.1756C24.7546 29.1756 25.337 27.9056 25.337 27.1904L24.8937 9.7822C24.8937 9.53688 24.7958 7.63746 24.6215 7.46398C24.9193 5.08896 23.605 4.54902 19.8255 4.35397Z"
            fill="url(#paint19_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint20_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint21_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint22_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint23_linear_7501_5321)"
            fill-opacity="0.13"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint24_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint25_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint26_radial_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint27_radial_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint28_radial_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint29_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint30_linear_7501_5321)"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint31_linear_7501_5321)"
            fill-opacity="0.55"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint32_linear_7501_5321)"
            fill-opacity="0.55"
      />
      <path d="M17.9832 2.31613C17.8083 2.14123 17.5711 2.04297 17.3237 2.04297H4.94877C4.22765 2.04297 3.64307 2.62755 3.64307 3.34867V26.7712C3.64307 27.4924 4.22765 28.0769 4.94877 28.0769H22.7827C23.5039 28.0769 24.0884 27.4924 24.0884 26.7712V8.8077C24.0884 8.56035 23.9902 8.32313 23.8153 8.14822L17.9832 2.31613Z"
            fill="url(#paint33_linear_7501_5321)"
      />
      <path d="M16.6219 2.42908C16.6219 2.24124 16.6758 2.08248 16.5736 2.0624C16.6707 2.06859 17.4833 1.99191 17.5707 2.0939C17.6856 2.13903 17.6166 2.32247 17.7066 2.41033C17.7092 2.4129 17.7118 2.41547 17.7144 2.41808L23.5464 8.25017C23.5642 8.26795 23.5812 8.28637 23.5974 8.30538C23.677 8.39897 23.718 8.37855 23.7554 8.49415C23.7852 8.58609 23.9989 8.39571 23.9989 8.49415L24.0706 8.63738V8.83736C24.0706 8.83736 24.1154 9.0713 23.9989 9.0713L17.9623 9.74399C17.0038 9.74399 16.1011 8.64217 16.1011 8.02408L16.6219 2.42908Z"
            fill="url(#paint34_linear_7501_5321)"
      />
      <path d="M16.6219 2.42908C16.6219 2.24124 16.6758 2.08248 16.5736 2.0624C16.6707 2.06859 17.4833 1.99191 17.5707 2.0939C17.6856 2.13903 17.6166 2.32247 17.7066 2.41033C17.7092 2.4129 17.7118 2.41547 17.7144 2.41808L23.5464 8.25017C23.5642 8.26795 23.5812 8.28637 23.5974 8.30538C23.677 8.39897 23.718 8.37855 23.7554 8.49415C23.7852 8.58609 23.9989 8.39571 23.9989 8.49415L24.0706 8.63738V8.83736C24.0706 8.83736 24.1154 9.0713 23.9989 9.0713L17.9623 9.74399C17.0038 9.74399 16.1011 8.64217 16.1011 8.02408L16.6219 2.42908Z"
            fill="url(#paint35_linear_7501_5321)"
      />
      <path d="M16.6219 2.42908C16.6219 2.24124 16.6758 2.08248 16.5736 2.0624C16.6707 2.06859 17.4833 1.99191 17.5707 2.0939C17.6856 2.13903 17.6166 2.32247 17.7066 2.41033C17.7092 2.4129 17.7118 2.41547 17.7144 2.41808L23.5464 8.25017C23.5642 8.26795 23.5812 8.28637 23.5974 8.30538C23.677 8.39897 23.718 8.37855 23.7554 8.49415C23.7852 8.58609 23.9989 8.39571 23.9989 8.49415L24.0706 8.63738V8.83736C24.0706 8.83736 24.1154 9.0713 23.9989 9.0713L17.9623 9.74399C17.0038 9.74399 16.1011 8.64217 16.1011 8.02408L16.6219 2.42908Z"
            fill="url(#paint36_linear_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint37_linear_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint38_linear_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint39_linear_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint40_linear_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint41_radial_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint42_radial_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint43_radial_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint44_radial_7501_5321)"
      />
      <path d="M17.6327 2.3272C17.6327 2.13936 17.4853 2.065 17.3831 2.04492C17.4802 2.05111 17.5751 2.07243 17.6645 2.10754C17.7794 2.15267 17.8853 2.22059 17.9753 2.30845C17.9779 2.31101 17.9805 2.31359 17.9831 2.31619L23.8152 8.14828C23.8329 8.16607 23.8499 8.18449 23.8661 8.2035C23.9457 8.29709 24.0056 8.40496 24.043 8.52055C24.0728 8.61249 24.0883 8.70933 24.0883 8.80777V8.86665C24.0883 8.65009 23.9317 8.52055 23.8152 8.52055H18.7519C18.1337 8.52055 17.6327 8.01948 17.6327 7.40138V2.3272Z"
            fill="url(#paint45_radial_7501_5321)"
      />
      <path d="M15.2905 19.7192C15.5459 19.7195 15.7524 19.9268 15.7524 20.1821C15.7524 20.4375 15.5459 20.6448 15.2905 20.645H7.83643C7.58089 20.645 7.37354 20.4377 7.37354 20.1821C7.37355 19.9266 7.58091 19.7192 7.83643 19.7192H15.2905ZM19.8882 16.9214C20.1435 16.9216 20.3501 17.1289 20.3501 17.3843C20.3501 17.6397 20.1435 17.8469 19.8882 17.8472H7.83643C7.5809 17.8472 7.37355 17.6398 7.37354 17.3843C7.37354 17.1287 7.58089 16.9214 7.83643 16.9214H19.8882ZM19.8882 14.1235C20.1435 14.1238 20.3501 14.331 20.3501 14.5864C20.35 14.8417 20.1435 15.0491 19.8882 15.0493H7.83643C7.58094 15.0493 7.37362 14.8419 7.37354 14.5864C7.37354 14.3309 7.58089 14.1235 7.83643 14.1235H19.8882ZM19.8882 11.3257C20.1435 11.3259 20.3501 11.5332 20.3501 11.7886C20.35 12.0439 20.1435 12.2512 19.8882 12.2515H7.83643C7.58096 12.2515 7.37365 12.044 7.37354 11.7886C7.37354 11.533 7.58089 11.3257 7.83643 11.3257H19.8882Z"
            fill="url(#paint46_linear_7501_5321)"
      />
      <path d="M24.0617 12.7275L22.4637 12.7287C22.3068 12.7287 22.1574 12.7984 22.0526 12.9205L21.0102 14.1345C20.9159 14.2444 20.9159 15.0639 21.0102 15.1738L22.0526 16.3878C22.1574 16.5099 22.3068 16.5797 22.4637 16.5797L24.0617 16.5785V12.7275Z"
            fill="url(#paint47_radial_7501_5321)"
            fill-opacity="0.75"
      />
      <path d="M24.0617 12.7275L22.4637 12.7287C22.3068 12.7287 22.1574 12.7984 22.0526 12.9205L21.0102 14.1345C20.9159 14.2444 20.9159 15.0639 21.0102 15.1738L22.0526 16.3878C22.1574 16.5099 22.3068 16.5797 22.4637 16.5797L24.0617 16.5785V12.7275Z"
            fill="url(#paint48_radial_7501_5321)"
            fill-opacity="0.75"
      />
      <path d="M24.0617 12.7275L22.4637 12.7287C22.3068 12.7287 22.1574 12.7984 22.0526 12.9205L21.0102 14.1345C20.9159 14.2444 20.9159 15.0639 21.0102 15.1738L22.0526 16.3878C22.1574 16.5099 22.3068 16.5797 22.4637 16.5797L24.0617 16.5785V12.7275Z"
            fill="url(#paint49_radial_7501_5321)"
            fill-opacity="0.75"
      />
      <path d="M24.0617 12.7275L22.4637 12.7287C22.3068 12.7287 22.1574 12.7984 22.0526 12.9205L21.0102 14.1345C20.9159 14.2444 20.9159 15.0639 21.0102 15.1738L22.0526 16.3878C22.1574 16.5099 22.3068 16.5797 22.4637 16.5797L24.0617 16.5785V12.7275Z"
            fill="url(#paint50_radial_7501_5321)"
            fill-opacity="0.75"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint51_linear_7501_5321)"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint52_linear_7501_5321)"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint53_linear_7501_5321)"
            fill-opacity="0.74"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint54_linear_7501_5321)"
            fill-opacity="0.74"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint55_linear_7501_5321)"
            fill-opacity="0.74"
      />
      <path d="M22.6307 13.3221C22.7255 13.2165 22.8607 13.1562 23.0026 13.1562H26.3031C26.4412 13.1562 26.5531 13.2682 26.5531 13.4062V15.6719C26.5531 15.8099 26.4412 15.9219 26.3031 15.9219H23.0026C22.8607 15.9219 22.7255 15.8616 22.6307 15.756L21.6876 14.7061C21.6022 14.6111 21.6022 14.467 21.6876 14.372L22.6307 13.3221Z"
            fill="url(#paint56_linear_7501_5321)"
            fill-opacity="0.74"
      />
      <path d="M27.531 19.5664L25.6894 19.5676C25.5086 19.5676 25.3364 19.6373 25.2156 19.7594L24.0144 20.9734C23.9057 21.0833 23.9057 21.9028 24.0144 22.0127L25.2156 23.2267C25.3364 23.3488 25.5086 23.4185 25.6894 23.4185L27.531 23.4174V19.5664Z"
            fill="url(#paint57_radial_7501_5321)"
      />
      <path d="M27.531 19.5664L25.6894 19.5676C25.5086 19.5676 25.3364 19.6373 25.2156 19.7594L24.0144 20.9734C23.9057 21.0833 23.9057 21.9028 24.0144 22.0127L25.2156 23.2267C25.3364 23.3488 25.5086 23.4185 25.6894 23.4185L27.531 23.4174V19.5664Z"
            fill="url(#paint58_radial_7501_5321)"
      />
      <path d="M27.531 19.5664L25.6894 19.5676C25.5086 19.5676 25.3364 19.6373 25.2156 19.7594L24.0144 20.9734C23.9057 21.0833 23.9057 21.9028 24.0144 22.0127L25.2156 23.2267C25.3364 23.3488 25.5086 23.4185 25.6894 23.4185L27.531 23.4174V19.5664Z"
            fill="url(#paint59_radial_7501_5321)"
      />
      <path d="M27.531 19.5664L25.6894 19.5676C25.5086 19.5676 25.3364 19.6373 25.2156 19.7594L24.0144 20.9734C23.9057 21.0833 23.9057 21.9028 24.0144 22.0127L25.2156 23.2267C25.3364 23.3488 25.5086 23.4185 25.6894 23.4185L27.531 23.4174V19.5664Z"
            fill="url(#paint60_radial_7501_5321)"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint61_linear_7501_5321)"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint62_linear_7501_5321)"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint63_linear_7501_5321)"
            fill-opacity="0.46"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint64_linear_7501_5321)"
            fill-opacity="0.46"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint65_linear_7501_5321)"
            fill-opacity="0.46"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint66_linear_7501_5321)"
            fill-opacity="0.46"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint67_radial_7501_5321)"
            fill-opacity="0.26"
      />
      <path d="M25.615 20.2752C25.7099 20.1697 25.8451 20.1094 25.987 20.1094H29.2875C29.4255 20.1094 29.5375 20.2213 29.5375 20.3594V22.625C29.5375 22.7631 29.4255 22.875 29.2875 22.875H25.987C25.8451 22.875 25.7099 22.8147 25.615 22.7091L24.6719 21.6593C24.5866 21.5642 24.5866 21.4201 24.6719 21.3251L25.615 20.2752Z"
            fill="url(#paint68_radial_7501_5321)"
            fill-opacity="0.73"
      />
    </g>
    <defs>
      <linearGradient id="paint0_linear_7501_5321"
                      x1="20.8267"
                      y1="24.25"
                      x2="28.3267"
                      y2="27.8125"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#AFAAB6" />
        <stop offset="1"
              stop-color="#B7B0C0"
        />
      </linearGradient>
      <linearGradient id="paint1_linear_7501_5321"
                      x1="8.76416"
                      y1="30.3125"
                      x2="21.2642"
                      y2="22.375"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A79FB2" />
        <stop offset="1"
              stop-color="#A79FB2"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint2_linear_7501_5321"
                      x1="27.6184"
                      y1="16.3399"
                      x2="27.2801"
                      y2="16.3399"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CECCD3" />
        <stop offset="1"
              stop-color="#CFCCD3"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint3_linear_7501_5321"
                      x1="27.1913"
                      y1="4.10937"
                      x2="27.1913"
                      y2="4.36249"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CFCCD3" />
        <stop offset="1"
              stop-color="#CFCCD3"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint4_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.5634 4.10938) rotate(27.5945) scale(1.23699 0.23196)"
      >
        <stop stop-color="#CFCCD3" />
        <stop offset="1"
              stop-color="#CFCCD3"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint5_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.9036 4.20353) rotate(45) scale(1.15833 0.439326)"
      >
        <stop stop-color="#CFCCD3" />
        <stop offset="1"
              stop-color="#CFCCD3"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint6_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.4454 4.73277) rotate(80.2933) scale(0.97158 0.368498)"
      >
        <stop stop-color="#CFCCD3" />
        <stop offset="1"
              stop-color="#CFCCD3"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint7_linear_7501_5321"
                      x1="17.3774"
                      y1="29.9843"
                      x2="17.3774"
                      y2="29.6868"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint8_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.40416 30.173) rotate(-3.80615) scale(1.66385 0.831029)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint9_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.2251 27.9903) rotate(86.4477) scale(1.58525 0.265608)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.2251 28.8796) rotate(54.7206) scale(1.32983 0.222812)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint11_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.5774 29.4455) rotate(35.3112) scale(1.01899 0.170732)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint12_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(25.9622 30.4394) rotate(-38.0944) scale(1.54704 0.422475)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.0154 29.8136) rotate(-53.541) scale(1.23377 0.336926)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(27.4262 29.3775) rotate(-75.8849) scale(1.11444 0.256045)"
      >
        <stop stop-color="#9887AC" />
        <stop offset="1"
              stop-color="#9887AC"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint15_linear_7501_5321"
                      x1="15.6249"
                      y1="27.7066"
                      x2="15.6249"
                      y2="29.0781"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91879F" />
        <stop offset="1"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint16_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.0248 27.9786) rotate(0.137396) scale(13.3489 2.02393)"
      >
        <stop offset="0.0885417"
              stop-color="#B4ADBD"
              stop-opacity="0"
        />
        <stop offset="0.5625"
              stop-color="#B5ADBD"
              stop-opacity="0"
        />
        <stop offset="0.949543"
              stop-color="#B5AEBD"
        />
      </radialGradient>
      <linearGradient id="paint17_linear_7501_5321"
                      x1="23.2187"
                      y1="18.4881"
                      x2="25.7274"
                      y2="18.4881"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.229167"
              stop-color="#91879F"
        />
        <stop offset="0.526042"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7501_5321"
                      x1="21.9004"
                      y1="34.9934"
                      x2="17.5637"
                      y2="12.3631"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B6AFBF" />
        <stop offset="1"
              stop-color="#B6AFBE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7501_5321"
                      x1="24.9506"
                      y1="4.95012"
                      x2="11.9606"
                      y2="14.295"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B0AAB7" />
        <stop offset="1"
              stop-color="#B6AFBE"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7501_5321"
                      x1="13.8658"
                      y1="2.04297"
                      x2="13.8658"
                      y2="28.0769"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EBE4F3" />
        <stop offset="1"
              stop-color="#E4DAF0"
        />
      </linearGradient>
      <linearGradient id="paint21_linear_7501_5321"
                      x1="13.8658"
                      y1="2.16126"
                      x2="13.8658"
                      y2="2.37909"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint22_linear_7501_5321"
                      x1="24.0884"
                      y1="14.4146"
                      x2="23.7692"
                      y2="14.4146"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F3F0F6" />
        <stop offset="1"
              stop-color="#F3F0F6"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint23_linear_7501_5321"
                      x1="24.3018"
                      y1="14.4146"
                      x2="23.9264"
                      y2="14.4146"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint24_linear_7501_5321"
                      x1="2.87921"
                      y1="14.4146"
                      x2="3.81234"
                      y2="14.4163"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint25_linear_7501_5321"
                      x1="15.2825"
                      y1="28.5729"
                      x2="15.2825"
                      y2="27.9025"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint26_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(4.18529 28.249) rotate(-72.992) scale(0.484182 1.57161)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint27_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.77131 27.8895) rotate(-60.2552) scale(0.439162 1.42547)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint28_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(3.6079 27.4156) rotate(-38.6597) scale(0.313908 1.01891)"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint29_linear_7501_5321"
                      x1="3.22247"
                      y1="26.7877"
                      x2="3.87412"
                      y2="26.7877"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint30_linear_7501_5321"
                      x1="2.92759"
                      y1="2.29372"
                      x2="4.1449"
                      y2="2.82255"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B5B0BB" />
        <stop offset="1"
              stop-color="#B5B0BB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint31_linear_7501_5321"
                      x1="3.14269"
                      y1="14.0574"
                      x2="4.08441"
                      y2="14.0574"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint32_linear_7501_5321"
                      x1="13.8658"
                      y1="28.0769"
                      x2="13.8658"
                      y2="27.8554"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint33_linear_7501_5321"
                      x1="23.5749"
                      y1="27.9164"
                      x2="23.44"
                      y2="27.6653"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B9A6CC" />
        <stop offset="1"
              stop-color="#B9A6CC"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint34_linear_7501_5321"
                      x1="18.813"
                      y1="4.73935"
                      x2="17.2121"
                      y2="4.73935"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.72"
              stop-color="#D2C5DE"
        />
        <stop offset="1"
              stop-color="#D2C5DF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint35_linear_7501_5321"
                      x1="21.07"
                      y1="10.6083"
                      x2="21.0585"
                      y2="8.49576"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.72"
              stop-color="#E9E1F3"
        />
        <stop offset="1"
              stop-color="#E9E1F3"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint36_linear_7501_5321"
                      x1="18.0476"
                      y1="7.84308"
                      x2="16.4658"
                      y2="10.3216"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E9E1F3"
              stop-opacity="0"
        />
        <stop offset="0.682292"
              stop-color="#E9E1F3"
        />
      </linearGradient>
      <linearGradient id="paint37_linear_7501_5321"
                      x1="18.099"
                      y1="8.25825"
                      x2="20.5618"
                      y2="5.79548"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D9D3E1" />
        <stop offset="1"
              stop-color="#CCC7D1"
        />
      </linearGradient>
      <linearGradient id="paint38_linear_7501_5321"
                      x1="21.1155"
                      y1="5.31458"
                      x2="20.518"
                      y2="5.89749"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.119171"
              stop-color="#DBDADC"
        />
        <stop offset="0.577307"
              stop-color="#CBC7D0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint39_linear_7501_5321"
                      x1="17.6108"
                      y1="4.56621"
                      x2="17.7486"
                      y2="4.56621"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#9D9CA7"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint40_linear_7501_5321"
                      x1="20.7357"
                      y1="8.56429"
                      x2="20.7357"
                      y2="8.37484"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C0ACD5" />
        <stop offset="1"
              stop-color="#C0ACD5"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint41_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.4213 8.62305) rotate(-81.1582) scale(0.344915 1.99733)"
      >
        <stop stop-color="#C0ACD5" />
        <stop offset="1"
              stop-color="#C0ACD5"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint42_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.8987 8.36555) rotate(-40.8602) scale(0.318734 1.84571)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint43_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.6279 8.06928) rotate(-24.7752) scale(0.314099 1.81888)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint44_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(17.4449 7.74538) rotate(-6.45541) scale(0.393741 2.28006)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint45_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(18.0314 8.4251) rotate(-59.8587) scale(0.256928 1.48781)"
      >
        <stop stop-color="#A19CA7" />
        <stop offset="1"
              stop-color="#A19CA7"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint46_linear_7501_5321"
                      x1="7.37354"
                      y1="20.1823"
                      x2="15.7526"
                      y2="20.1823"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#9C96A2" />
        <stop offset="1"
              stop-color="#9A95A1"
        />
      </linearGradient>
      <radialGradient id="paint47_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.6502 13.8952) rotate(-130.882) scale(0.782073 1.38937)"
      >
        <stop stop-color="#BAA8C1" />
        <stop offset="1"
              stop-color="#BAA8C1"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint48_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.0413 14.4777) rotate(-138.18) scale(0.675005 1.19916)"
      >
        <stop stop-color="#BAA8C1" />
        <stop offset="1"
              stop-color="#BAA8C1"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint49_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.3379 15.3037) rotate(43.3865) scale(1.2655 0.893478)"
      >
        <stop stop-color="#BAA8C1" />
        <stop offset="1"
              stop-color="#BAA8C1"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint50_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(23.58 15.8161) scale(1.56031 0.616794)"
      >
        <stop offset="0.27157"
              stop-color="#BAA8C1"
        />
        <stop offset="1"
              stop-color="#BAA8C1"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint51_linear_7501_5321"
                      x1="24.0883"
                      y1="13.1562"
                      x2="24.0883"
                      y2="15.9219"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E0437B" />
        <stop offset="1"
              stop-color="#DC4369"
        />
      </linearGradient>
      <linearGradient id="paint52_linear_7501_5321"
                      x1="22.0297"
                      y1="13.9062"
                      x2="22.4203"
                      y2="14.2187"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.263415"
              stop-color="#CA4A72"
        />
        <stop offset="1"
              stop-color="#CA4A72"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint53_linear_7501_5321"
                      x1="22.6297"
                      y1="15.4423"
                      x2="22.8252"
                      y2="15.2468"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B83960" />
        <stop offset="1"
              stop-color="#B83960"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint54_linear_7501_5321"
                      x1="25.1145"
                      y1="15.7396"
                      x2="25.1145"
                      y2="15.585"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B83960" />
        <stop offset="1"
              stop-color="#B83960"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint55_linear_7501_5321"
                      x1="24.0883"
                      y1="13.0694"
                      x2="24.0883"
                      y2="13.7035"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC6693" />
        <stop offset="1"
              stop-color="#EC6693"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint56_linear_7501_5321"
                      x1="26.5531"
                      y1="13.7035"
                      x2="25.9796"
                      y2="13.7035"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EC6693" />
        <stop offset="1"
              stop-color="#EC6693"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint57_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.589875 -0.591295 1.21053 -0.909342 25.9044 20.7341)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91879F" />
        <stop offset="1"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint58_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.579705 -0.45009 0.92145 -0.893663 25.2026 21.3165)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91879F" />
        <stop offset="1"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint59_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(1.05985 0.869293 -0.707277 0.649323 25.5444 22.1425)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#91879F" />
        <stop offset="1"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint60_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.9758 22.655) scale(1.7981 0.616794)"
      >
        <stop offset="0.27157"
              stop-color="#91879F"
        />
        <stop offset="1"
              stop-color="#91879F"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint61_linear_7501_5321"
                      x1="27.0727"
                      y1="20.1094"
                      x2="27.0727"
                      y2="22.875"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E4BD58" />
        <stop offset="1"
              stop-color="#D89D52"
        />
      </linearGradient>
      <linearGradient id="paint62_linear_7501_5321"
                      x1="25.014"
                      y1="20.8594"
                      x2="25.4984"
                      y2="21.2187"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.263415"
              stop-color="#AB9365"
        />
        <stop offset="1"
              stop-color="#E3B758"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint63_linear_7501_5321"
                      x1="25.5083"
                      y1="22.2839"
                      x2="25.7534"
                      y2="22.0388"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A56947" />
        <stop offset="1"
              stop-color="#A56747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint64_linear_7501_5321"
                      x1="27.8354"
                      y1="22.7124"
                      x2="27.8354"
                      y2="22.4338"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A56947" />
        <stop offset="1"
              stop-color="#A56747"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint65_linear_7501_5321"
                      x1="27.8354"
                      y1="20.2667"
                      x2="27.8354"
                      y2="20.538"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCED70" />
        <stop offset="1"
              stop-color="#FCED70"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint66_linear_7501_5321"
                      x1="29.5375"
                      y1="20.538"
                      x2="29.0809"
                      y2="20.538"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCED70" />
        <stop offset="1"
              stop-color="#FCED70"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint67_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(26.2331 23.0009) rotate(-67.5431) scale(0.549149 0.978826)"
      >
        <stop stop-color="#A56947" />
        <stop offset="1"
              stop-color="#A56747"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint68_radial_7501_5321"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(29.198 23.2826) rotate(-45) scale(1.54252 0.851538)"
      >
        <stop stop-color="#A56947" />
        <stop offset="0.98754"
              stop-color="#A56747"
              stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_7501_5321">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
